
//获取菜单列表
export const getList = () => {
    return new Promise((resolve, reject) => {
        resolve(menus);
    });
}

//临时菜单数据源
const menus = [
    {
        title: "首页",
        route: "/",
        icon: "sz szshouye",
        auth: 0,
        sub: [
            {
                title: "首页",
                path: "/",
                route: "/",
                icon: "sz szshouye",
                auth: 0,
                sub: []
            },

        ]
    },
    {
        title:"投稿",
        route: "/contribution",
        icon: "sz sztougao",
        auth: 1,
        sub: [{
            title: "投稿",
            path: "/src/views/contribution/index.vue",
            route: "/contribution",
            icon: "sz sztougao",
            auth: 0,
            sub: []
        },]
    },
    {
        title:"征文",
        route: "/essay",
        icon: "sz szminyizhengji",
        auth: 2,
        sub: [{
            title: "征文",
            path: "/src/views/essay/index.vue",
            route: "/essay",
            icon: "sz szminyizhengji",
            auth: 0,
            sub: []
        },]
    },
    {
        title:"期刊",
        route: "/periodical",
        icon: "sz szzazhiqikan",
        auth: 4,
        sub: [{
            title: "期刊",
            path: "/src/views/periodical/index.vue",
            route: "/periodical",
            icon: "sz szzazhiqikan",
            auth: 0,
            sub: []
        },]
    },
];